import { IVideo } from "../models/video/video.model";
import { ILiveStream } from "../models/live-stream/live-stream.model";
import { ELiveStreamStatus } from "../enums/live-stream-status.enum";

/** Served from `shared/assets`, so both applications resolve it at the same path. */
export const CONTENT_FALLBACK_IMAGE = 'assets/img/video-dummy.jpg';

/**
 * A video or a live stream wherever the two are shown side by side — a library card, a task that
 * points at something to watch. Only one of the two is ever set.
 */
export interface IWatchableContent {
  video?: IVideo | null;
  liveStream?: ILiveStream | null;
}

/** The cover to show, falling back to the placeholder when the content has no poster. */
export function contentPosterUrl(content: IWatchableContent, fallback = CONTENT_FALLBACK_IMAGE): string {
  const thumbnails = content.video?.thumbnails ?? content.liveStream?.thumbnails;
  return thumbnails?.medium ?? thumbnails?.small ?? fallback;
}

/**
 * Length in milliseconds, or null when there is nothing to measure yet — a live stream only has a
 * duration once it has finished and its recording exists.
 */
export function contentDuration(content: IWatchableContent): number | null {
  if (content.video) {
    return content.video.duration ?? null;
  }

  return content.liveStream?.video?.duration ?? null;
}

/** True while a live stream is on air, which is what the poster shows instead of a duration. */
export function isLiveNow(liveStream?: ILiveStream | null): boolean {
  return liveStream?.status === ELiveStreamStatus.Starting || liveStream?.status === ELiveStreamStatus.Started;
}
